import React, { Component } from 'react'
import array from 'lodash/array'
import lang from 'lodash/lang'
import collection from 'lodash/collection'
import object from 'lodash/object'
import uuidv4 from 'uuid/v4'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import OptionStepper from '../containers/components/OptionStepper'

class OptionGroupsComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedRadioItem: null,
      itemOptions: [],
      itemNameWidth: window.innerWidth - 30 - 100 - 30, // (screen width, padding left/right, stepper, price)
    }
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resizeDimension)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeDimension)
  }

  resizeDimension = () => {
    this.setState({
      itemNameWidth: window.innerWidth - this.itemNameWidth,
    })
  }

  onChangeByInputLabel = (item, groupName, groupId, dishId, inputType, isIncrementQty, event) => {
    const {
      // stash,
      // stashByOptionGroups,
      stashByRadioGroups,
      addStashByOptionGroups,
      removeStashByOptionGroups,
      addStashByRadioGroups,
      groupMax,
      groupMin,
      checkOptionGroupMin,
    } = this.props

    const option = {
      group: groupName,
      groupId: groupId,
      groupOptionMax: groupMax,
      groupOptionMin: groupMin,
      groupOptionQty: 1,
      dishId: dishId,
      options: [item],
      optionType: inputType,
    }

    if (inputType === 'stepper') {
      if (isIncrementQty) {
        addStashByOptionGroups(option).then(() => {
          checkOptionGroupMin()
        })
      } else {
        removeStashByOptionGroups(option).then(() => {
          checkOptionGroupMin()
        })
      }
    } else {
      if (inputType === 'radio') {
        const _event = event.target.value
        const _radioGroups = object.keys(stashByRadioGroups)
        const _radioGroup = {
          [groupId]: item.id,
        }

        addStashByRadioGroups(_radioGroup).then(() => {
          if (lang.isEmpty(_radioGroups)) {
            addStashByOptionGroups(option).then(() => {
              checkOptionGroupMin()
            })
          } else {
            const _item = collection.find(_radioGroups, (item) => {
              return item === groupId
            })

            if (stashByRadioGroups[_item] === _event) {
              removeStashByOptionGroups(option).then(() => {
                checkOptionGroupMin()
              })
            } else {
              addStashByOptionGroups(option).then(() => {
                checkOptionGroupMin()
              })
            }
          }
        })
      } else {
        if (event.target.checked) {
          addStashByOptionGroups(option).then(() => {
            checkOptionGroupMin()
          })
        } else {
          removeStashByOptionGroups(option).then(() => {
            checkOptionGroupMin()
          })
        }
      }
    }
  }

  renderItemOptionPrice = (price) => {
    const {
      classes,
    } = this.props

    const itemOptionPriceTextStyle = cx(classes['item-option-price-text'])

    if (!price) {
      return
    }
    return (
      <span>
        <span>
          (+
        </span>
        <FontAwesomeIcon icon='dollar-sign' />
        <span className={itemOptionPriceTextStyle}>
          {price}
        </span>
        <span>
          )
        </span>
      </span>
    )
  }

  render () {
    const {
      classes,
      item,
      groupName,
      groupId,
      inputType,
      dishId,
      checked,
      groupMax,
      stashByOptionGroups,
      stashByRadioGroups,
    } = this.props

    const wrapStyle = cx(classes.wrap)
    const radioInputStyle = cx(classes['radio-input'])
    const itemOptionNameStyle = cx(classes['item-option-name'])
    const itemOptionPriceStyle = cx(classes['item-option-price'])
    const itemOptionDisableOverlayStyle = cx(classes['item-option-disable-overlay'])
    const uuid = uuidv4()

    let itemOptionNameDisableStyle = ''
    let isDisableComponent = false
    let optionOverlayElement = ''
    let isMax = false

    if (!lang.isEmpty(stashByOptionGroups)) {
      const _filterGroupResult = collection.filter(stashByOptionGroups, (group) => {
        return group.groupId === groupId
      })

      if (!lang.isEmpty(_filterGroupResult)) {
        const _headOfGroupResult = array.head(_filterGroupResult)

        if (groupMax !== 0 && groupMax > 0) {
          if (_headOfGroupResult.groupOptionQty >= groupMax) {
            const _item = _headOfGroupResult.options.some((option) => {
              return option.id === item.id
            })

            isMax = true

            if (!_item) {
              itemOptionNameDisableStyle = cx(classes['item-option-name-disable'])
              isDisableComponent = true
              optionOverlayElement = (
                <div className={itemOptionDisableOverlayStyle} />
              )
            }
          }
        }
      }
    }

    if (inputType === 'stepper') {
      return (
        <div className={wrapStyle}>

          {optionOverlayElement}

          <div
            className={`${itemOptionNameStyle} ${itemOptionNameDisableStyle}`}
            style={{
              maxWidth: `${this.state.itemNameWidth}px`,
            }}
          >
            {item.name}
            <span className={itemOptionPriceStyle}>
              {this.renderItemOptionPrice(item.price)}
            </span>
          </div>
          <OptionStepper
            stepperOnChange={this.onChangeByInputLabel}
            item={item}
            groupName={groupName}
            groupId={groupId}
            dishId={dishId}
            inputType={inputType}
            isDisabled={isDisableComponent}
            isDisabledIncreaseBtn={isMax}
          />
        </div>
      )
    } else if (inputType === 'radio') {
      let isIncrementQty
      let _radioItemId = ''
      let isChecked = false

      if (!lang.isEmpty(stashByRadioGroups)) {
        _radioItemId = stashByRadioGroups[groupId]
        isChecked = _radioItemId === item.id
      }

      return (
        <div className={wrapStyle}>
          {optionOverlayElement}
          <input
            type={inputType}
            id={uuid}
            name={groupId}
            className={radioInputStyle}
            value={item.id}
            checked={isChecked}
            disabled={isDisableComponent}
            onClick={
              (event) => this.onChangeByInputLabel(item, groupName, groupId, dishId, inputType, isIncrementQty, event)
            }
            onChange={() => { }}
          />
          <label htmlFor={uuid}>
            <div className={`${itemOptionNameStyle} ${itemOptionNameDisableStyle}`}>
              {item.name}
              <span className={itemOptionPriceStyle}>
                {this.renderItemOptionPrice(item.price)}
              </span>
            </div>
          </label>

        </div>
      )
    } else {
      const isIncrementQty = undefined

      return (
        <div className={wrapStyle}>

          {optionOverlayElement}

          <input
            type={inputType}
            id={uuid}
            name={groupId}
            className={radioInputStyle}
            value={item.id}
            defaultChecked={checked}
            disabled={!!isDisableComponent}
            onChange={
              (event) => this.onChangeByInputLabel(item, groupName, groupId, dishId, inputType, isIncrementQty, event)
            }
          />
          <label
            htmlFor={uuid}
          >
            <div className={`${itemOptionNameStyle} ${itemOptionNameDisableStyle}`}>
              {item.name}
              <span className={itemOptionPriceStyle}>
                {this.renderItemOptionPrice(item.price)}
              </span>
            </div>
          </label>

        </div>
      )
    }
  }
};

export default OptionGroupsComponent



// WEBPACK FOOTER //
// ./src/components/OptionGroups.js